import { H1_BASE_CSS_VARS } from "./H1";
import { H2_BASE_CSS_VARS } from "./H2";
import { H3_BASE_CSS_VARS } from "./H3";
import { H4_BASE_CSS_VARS } from "./H4";
import { H5_BASE_CSS_VARS } from "./H5";
import { H6_BASE_CSS_VARS } from "./H6";
import { P1_BASE_CSS_VARS } from "./P1";
import { P2_BASE_CSS_VARS } from "./P2";
import { P3_BASE_CSS_VARS } from "./P3";

export const TYPOGRAPHY_BASE_CSS_VARS = {
  h1: H1_BASE_CSS_VARS,
  h2: H2_BASE_CSS_VARS,
  h3: H3_BASE_CSS_VARS,
  h4: H4_BASE_CSS_VARS,
  h5: H5_BASE_CSS_VARS,
  h6: H6_BASE_CSS_VARS,
  p1: P1_BASE_CSS_VARS,
  p2: P2_BASE_CSS_VARS,
  p3: P3_BASE_CSS_VARS,
};
